import Query from "@qpr/client-api-base/querybuilder/Query";
import { ICardElement } from "./model";

export const getTopLevel = async (id: string) => {
  return Query(id)
    .topelement()
    .attributes("name", "typename", "symbol", "description")
    .fetchValues<ICardElement>();
};
